import React from 'react';
import { Banner } from '@shopify/polaris';

const BannerComponent = ({ onDismiss, tone, children }) => {
    return <Banner onDismiss={onDismiss} tone={tone}>{children}</Banner>;
};

export default BannerComponent;
